import React from 'react';
import { motion } from 'framer-motion';
import { MayaTestimonial } from '../components/landing/MayaTestimonial';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HeroSection } from '../components/landing/HeroSection';

export const MayaPage: React.FC = () => {
  return (
    <div className="space-y-24">
      <MayaTestimonial />
      <HeroSection />
      <div className="mt-24">
        <FeaturesSection />
      </div>
    </div>
  );
};